/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */


import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import * as models from '../model/models';
import { Requester } from '../requester';
import { PagedArray } from '../paged-array';

/* tslint:disable:no-unused-variable member-ordering */


@Injectable()
export class LegacyApi {
    constructor(
        protected requester: Requester
    ) {
    }

    /**
     * Profile changed hook
     * @param user_id 
     */
    public profileChanged(user_id?: number, __unused?: any): Observable<{}> {
        const path = '/legacy/hooks/profile_changed/{user_id}'
                    .replace('{' + 'user_id' + '}', String(user_id));

        let queryParameters : Record<string,string> = {};
        let headers : Record<string,string> = {}; 

        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;

        return this.requester
            .request<any>(
                requestMethodStr, 
                requestPath, 
                queryParameters,
                headers,
            );
    }

    /**
     * Membership changed hook
     * @param user_id 
     * @param level_id 
     */
    public membershipChanged(user_id?: number, level_id?: number, __unused?: any): Observable<{}> {
        const path = '/legacy/hooks/membership_changed/{user_id}/{level_id}'
                    .replace('{' + 'user_id' + '}', String(user_id))
                    .replace('{' + 'level_id' + '}', String(level_id));

        let queryParameters : Record<string,string> = {};
        let headers : Record<string,string> = {}; 

        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;

        return this.requester
            .request<any>(
                requestMethodStr, 
                requestPath, 
                queryParameters,
                headers,
            );
    }

    /**
     * Legacy user password changed
     * @param password 
     * @param user_id 
     */
    public passwordChanged(password?: string, user_id?: number, __unused?: any): Observable<{}> {
        const path = '/legacy/hooks/password_changed/{user_id}'
                    .replace('{' + 'user_id' + '}', String(user_id));

        let queryParameters : Record<string,string> = {};
        let headers : Record<string,string> = {}; 

        let requestMethodStr = 'RequestMethod.Post'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;

        return this.requester
            .request<any>(
                requestMethodStr, 
                requestPath, 
                queryParameters,
                headers,
            );
    }

}
